import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DDFSQuoteModel, DDFSQuoteLineModel } from '../../models/shopping-cart.model';
import { DDFSQuoteTermLine, DDFSQuoteResponse, DDFSQuoteTermResponse, ApiResponse } from '../../models/api-response.model';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { CommonService } from '../../services';

@Component({
  selector: 'app-finance-quotes-summary',
  templateUrl: './finance-quotes-summary.component.html',
  styleUrls: ['./finance-quotes-summary.component.css']
})
export class FinanceQuotesSummaryComponent implements OnInit {
  @ViewChild("ParentWrapper", { static: true }) parentWrapper: ElementRef;
  title = 'Summary';
  loadContent = false;
  setFullWindow = false;
  quote: DDFSQuoteModel;
  cartId: string;
  cartName: string;
  accountNumber = '';
  accountName = '';
  bsb = '';
  displayedColumns: string[];
  displayedColumnsAdditional: string[] = ['SKU', 'DESCRIPTION', 'QTY', 'UNITPRICE', 'LINEPRICE'];
  displayedColumnsPass: string[] = ['SKU', 'DESCRIPTION', 'QTY', 'UNITPRICE', 'LINEPRICE'];
  shoppingCartItems: DDFSQuoteLineModel[] = [];
  additionalCharges: DDFSQuoteLineModel[] = [];
  passThroughCharges: DDFSQuoteLineModel[] = [];
  terms: DDFSQuoteTermLine[] = [];
  selectedTerm: DDFSQuoteTermLine;
  dataSourceItems = new MatTableDataSource();
  dataSourceAdditionalCharge = new MatTableDataSource();
  dataSourcePastThrough = new MatTableDataSource();
  url: string;
  totalPrice: number;
  additionalChargeTotalPrice: number;
  passThroughChargeTotalPrice: number;
  financeType: string;
  quoteName: string;
  editCartId: string;
  editQuoteName: string;

  constructor(
    private router: Router,
    private activeRouter: ActivatedRoute,
    private shoppingCartService: ShoppingCartService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.activeRouter.paramMap.subscribe(res => {
      if (res) {
        this.cartId = res.get('id');
        this.cartName = res.get('cartName');
        this.loadContent = false;
        this.shoppingCartService.GetFinanceQuoteByCartId(this.commonService.toNumber(this.cartId), '', false).subscribe((response: DDFSQuoteResponse) => {
          this.totalPrice = 0;
          this.additionalChargeTotalPrice = 0;
          this.passThroughChargeTotalPrice = 0;
          if (response) {
            this.quote = response.quote;
            this.quoteName = decodeURIComponent(this.quote.name);
            this.editQuoteName = this.quote.name;
            this.accountNumber = this.quote.accountNumber === '0' ? '' : this.quote.accountNumber;
            this.accountName = this.quote.accountName;
            this.bsb = this.quote.bsb;
            if (this.quote.financeType === 2) {
              this.displayedColumns = ['SKU', 'DESCRIPTION', 'QTY', 'UNITPRICE', 'LINEPRICE', 'SELLINGPRICE', 'SELLINGLINEPRICE'];
            } else {
              this.displayedColumns = ['SKU', 'DESCRIPTION', 'QTY', 'UNITPRICE', 'LINEPRICE'];
            }
            this.shoppingCartService.GetFinanceQuoteTermAmount(response).subscribe((termRes: DDFSQuoteTermResponse) => {
              this.shoppingCartItems = response.items;
              if (response && response.additionalChanrges.length) {
                this.additionalCharges = response.additionalChanrges.filter(x => x.description);
              }
              if (response && response.passThroughChanrges.length) {
                this.passThroughCharges = response.passThroughChanrges.filter(x => x.description);
              }
              if (this.passThroughCharges && this.passThroughCharges.length) {
                this.passThroughCharges.forEach(ac => {
                  ac.lineSellPrice = ac.sellPrice * ac.quantity;
                  this.passThroughChargeTotalPrice += ac.lineSellPrice;
                });
                this.dataSourcePastThrough = new MatTableDataSource(this.passThroughCharges);
              }
              if (this.additionalCharges && this.additionalCharges.length) {
                this.additionalCharges.forEach(ac => {
                  ac.lineSellPrice = ac.sellPrice * ac.quantity;
                  this.additionalChargeTotalPrice += ac.lineSellPrice;
                });
                this.dataSourceAdditionalCharge = new MatTableDataSource(this.additionalCharges);
              }
              this.shoppingCartItems.forEach(item => {
                item.linePrice = item.unitPrice * item.quantity;
                if (this.quote.financeType === 2) {
                  this.totalPrice += item.lineSellPrice;
                } else {
                  this.totalPrice += item.linePrice;
                }
              });
              this.dataSourceItems = new MatTableDataSource(this.shoppingCartItems);
              this.loadContent = true;
              if (termRes && termRes.terms) {
                this.terms = termRes.terms;
                if (this.quote.termInMonths) {
                  this.selectedTerm = this.terms.filter(ter => ter.termId === this.quote.termInMonths)[0];
                }
              }
              this.commonService.applyScrollFixedHeader(this.parentWrapper);
            },
              (error: any) => {
                console.error(error);
                this.loadContent = true;
              });
          } else {
            this.loadContent = true;
          }
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
      }
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  setEditQuoteCart(cartId: string): void {
    this.editCartId = cartId;
    this.editQuoteName = this.quote.name;
  }

  confirmQuoteNameValue(): void {
    this.loadContent = false;
    this.editCartId = '0';
    this.shoppingCartService.updateQuoteName(this.editQuoteName, this.commonService.toNumber(this.cartId))
      .subscribe((success: ApiResponse) => {
        if (success.status) {
          this.shoppingCartService.monitorCartNameChange(this.editQuoteName);
          this.loadContent = true;
          this.quote.name = this.editQuoteName;
          this.quoteName = this.editQuoteName;
        } else {
          this.commonService.showError('.edit-input', success.responseMessage, 'right');
          this.loadContent = true;
        }
      },
        (error: any) => {
          this.loadContent = true;
          console.error(error);
        });
  }

  validateCartName(event: any): void {
    const pattern: RegExp = /[!@#$%^&*(),.?":{}|<>\s]/g;
    if (event.inputType === 'insertText') {
      // let inputChar = String.fromCharCode(event.data);
      if (pattern.test(event.data)) {
        // invalid character, prevent input
        event.target.value = event.target.value.replace(pattern, '');
      }
    } else if (event.inputType === 'insertFromPaste') {
      if (pattern.test(event.target.value)) {
        // invalid input added from Paste
        event.target.value = event.target.value.replace(pattern, '');
      }
    }
  }

  modifyQuote(): void {
    this.loadContent = false;
    this.shoppingCartService.ModifyFinanceQuote(this.quote.id).subscribe((res: ApiResponse) => {
      this.loadContent = true;
      this.financeType = '';
      if (res.status) {
        if (this.quote.financeType === 1) {
          this.financeType = 'me';
        } else {
          this.financeType = 'enduser';
        }
        this.router.navigateByUrl('/myCarts/cart/' + this.cartId + '/' + this.cartName + '/finance/financeDetails/' + this.financeType);
      } else {
        this.commonService.showError('.check-out-finance', 'Modify quote failed', 'right');
      }
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close(): void {
    this.router.navigateByUrl('/home');
  }
}
